"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Card;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GenericStore = require("../store/GenericStore");

var _reactI18next = require("react-i18next");

var _Component = _interopRequireDefault(require("../../render/Component"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    card: {
      width: '100%',
      padding: '10px 0'
    },
    title: {
      width: '100%',
      display: 'flex',
      fontSize: '20px'
    },
    number: {
      flexShrink: 0,
      paddingRight: '2px'
    },
    titleText: {
      flexShrink: 1
    },
    component: {
      padding: '10px 0'
    },
    required: {
      color: 'red'
    }
  };
});

function Card(props) {
  var _props$block = props.block,
      formComponents = _props$block.content,
      title = _props$block.title,
      blockPath = _props$block.path,
      parentPath = props.parentPath,
      number = props.number;
  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var isMandatory = formComponents === null || formComponents === void 0 ? void 0 : formComponents.some(function (component) {
    var _component$validators;

    return (component === null || component === void 0 ? void 0 : (_component$validators = component.validators) === null || _component$validators === void 0 ? void 0 : _component$validators.length) > 0;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.card
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.number
  }, "".concat(number, ".")), /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.titleText
  }, t(title)), isMandatory && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.required
  }, "*")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.component
  }, formComponents.map(function (component) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.component
    }, /*#__PURE__*/_react["default"].createElement(_Component["default"], {
      block: component,
      parentPath: parentPath + (blockPath ? blockPath : ''),
      store: _GenericStore.dataStore,
      key: parentPath + component.path
    }));
  }))));
}